/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  MonthPlanStateFundDto,
  MonthPlanStateFundDtoFromJSON,
  MonthPlanStateFundDtoFromJSONTyped,
  MonthPlanStateFundDtoToJSON,
} from "./MonthPlanStateFundDto";
import {
  MonthPlanStateWeekItemDto,
  MonthPlanStateWeekItemDtoFromJSON,
  MonthPlanStateWeekItemDtoFromJSONTyped,
  MonthPlanStateWeekItemDtoToJSON,
} from "./MonthPlanStateWeekItemDto";

/**
 *
 * @export
 * @interface MonthPlanStateVariableCostFromMarginDto
 */
export interface MonthPlanStateVariableCostFromMarginDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanStateVariableCostFromMarginDto
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateVariableCostFromMarginDto
   */
  percent: number;
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateVariableCostFromMarginDto
   */
  plan: number;
  /**
   *
   * @type {number}
   * @memberof MonthPlanStateVariableCostFromMarginDto
   */
  fact: number;
  /**
   *
   * @type {MonthPlanStateFundDto}
   * @memberof MonthPlanStateVariableCostFromMarginDto
   */
  fund: MonthPlanStateFundDto;
  /**
   *
   * @type {Array<MonthPlanStateWeekItemDto>}
   * @memberof MonthPlanStateVariableCostFromMarginDto
   */
  weeks: Array<MonthPlanStateWeekItemDto>;
}

export function MonthPlanStateVariableCostFromMarginDtoFromJSON(json: any): MonthPlanStateVariableCostFromMarginDto {
  return MonthPlanStateVariableCostFromMarginDtoFromJSONTyped(json, false);
}

export function MonthPlanStateVariableCostFromMarginDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanStateVariableCostFromMarginDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    percent: json["percent"],
    plan: json["plan"],
    fact: json["fact"],
    fund: MonthPlanStateFundDtoFromJSON(json["fund"]),
    weeks: (json["weeks"] as Array<any>).map(MonthPlanStateWeekItemDtoFromJSON),
  };
}

export function MonthPlanStateVariableCostFromMarginDtoToJSON(
  value?: MonthPlanStateVariableCostFromMarginDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    percent: value.percent,
    plan: value.plan,
    fact: value.fact,
    fund: MonthPlanStateFundDtoToJSON(value.fund),
    weeks: (value.weeks as Array<any>).map(MonthPlanStateWeekItemDtoToJSON),
  };
}
